export enum StripeWalletButtonTheme {
  light = 'light',
  dark = 'dark',
}
